import React, { useRef, useState } from "react";

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";

import { Building2, ChevronUp, ChevronDown } from "lucide-react";
import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { useDossier, useDossierDispatch, DOSSIER_ACTIONS } from "@app/contexts/DossierContext";
import { useToast } from '@app/components/3_modules/ToastContainer';

import ContractStructureDataRow from "@app/components/2_widgets/dossiers/ContractStructureDataRow";
import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";
import Badge from "@app/components/1_elements/Badge";

export default function SectionContract({ }) {
    const [displaying, setDisplaying] = useState(false);

    const auth = useAuth();
    const dossier = useDossier();
    const dossierDispatch = useDossierDispatch();
    const toast = useToast();

    const refStructureDatas = useRef([]);

    function updateStructureData(event) {
        event.preventDefault();

        // If missing a value - cannot validate the contract
        let error = false;
        
        refStructureDatas.current.forEach((refSD) => {
            const formData = new FormData();
            
            let structureData = refSD.getStructureData();
            let eligibilityValue = refSD.getEligibilityValue();
            let kvaPower = refSD.getKvaPower();

            // Error if missing value
            if (!eligibilityValue || !kvaPower)
                error = true;
            
            formData.append("structure_data[eligibility_value]", eligibilityValue ?? "")
            formData.append("structure_data[kva_power]", kvaPower ?? "")

            apiCall({
                method: "patch",
                path: `/api/v1/structure_datas/${structureData.id}`,
                auth: auth,
                data: formData,
                onSuccess: (response) => {}
            });
        });

        if (error) {
            toast.addToast(
                "Problème de validation du contrat",
                "Des données sont manquantes pour valider le contrat"          
            );
            updateStatus("pending_quotation_signature");            
        } else {
            updateStatus("validated_dossier");            
        }
    }

    function updateStatus(status) {
        const formData = new FormData();
        formData.append("dossier[status]", status);

        apiCall({
            method: "patch",
            path: `/api/v1/dossiers/${dossier.id}`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,
                    payload: response.data.dossier
                });
            }
        });
    }

    function displayContent() {
        if (!displaying)
            return;        

        return (
            <div>
                <table className="custom-table">
                    <thead>
                        <tr>
                            <th key="1">
                                Compteur
                            </th>
                            <th key="2">
                                % éligibles tarif réduit
                            </th>
                            <th key="3">
                                Tranche de puissance
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {dossier.structure_datas?.map(displayRow)}
                    </tbody>
                </table> 
                <div className="text-end">
                    <ButtonPrimary label="Valider le contrat" onClick={updateStructureData}/>
                </div>                
            </div>            
        )        
    }

    function displayRow(structureData, index) {
        return (
            <ContractStructureDataRow 
                ref={ref => refStructureDatas.current[index] = ref}
                key={index} 
                structureData={structureData}                
            />
        )
    }

    const badgeStatus = dossier.validated_dossier ? "validated" : "in_progress";
    const badgeLabel = dossier.validated_dossier ? "Terminé" : "En cours";
    
    return (
        <div className="page-section">
            <SectionTitle
                icon={<Building2 />}
                title="Contrat"
                onClick={() => setDisplaying(!displaying)}
                rightIcon={displaying ? <ChevronUp /> : <ChevronDown />}
                subtitle="Informations pré-remplies depuis les factures (modifiables)"
                badge={<Badge label={badgeLabel} classProp={`badge-${badgeStatus}`} />}
            />
            {displayContent()}                                   
        </div>
    )
}